import React from "react";

import { anim } from "./utils";
import { useAnimationsEnabled } from "../../lib/hooks/useQueryBoard";

const moveLeft = (delay: number) => ({
  initial: { x: 200, opacity: 0 },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.35,
      delay,
      ease: "easeOut",
    },
  },
});

const MoveLeft = (props: {
  children: React.ReactElement;
  delay: number;
  disabled?: boolean;
}) => {
  const { children, disabled, delay } = props;

  const animationsEnabled = useAnimationsEnabled();

  if (disabled || !animationsEnabled) {
    return children;
  }

  return React.cloneElement(children, {
    ...anim(moveLeft(delay)),
  });
};

export default MoveLeft;
